import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { rememberDestination } from '../lib/sso';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isGuest, shareExpired, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
          <p className="text-gray-400">Загрузка...</p>
        </div>
      </div>
    );
  }

  if (shareExpired) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
        <div className="text-center max-w-md">
          <div className="text-6xl mb-6">🔗</div>
          <h2 className="text-2xl font-bold text-white mb-3">Ссылка устарела</h2>
          <p className="text-gray-400 mb-6">
            Эта ссылка действительна только 24 часа с момента создания.
            Обратитесь к автору сессии, чтобы он прислал новую ссылку.
          </p>
          <a
            href="/auth"
            className="inline-block px-6 py-3 bg-orange-600 hover:bg-orange-500 text-white rounded-full font-medium transition-colors"
          >
            Войти в аккаунт
          </a>
        </div>
      </div>
    );
  }

  if (!isAuthenticated && !isGuest) {
    // Запоминаем, куда человек шёл: по ссылке из кабинета он приходит сразу на
    // конкретную запись, и после входа его надо вернуть именно туда, а не на
    // главную. Через SSO это переживает уход на гипнозио и обратно.
    rememberDestination(location.pathname + location.search);
    return <Navigate to="/auth" replace />;
  }

  return children;
};

export default ProtectedRoute;
